/* eslint-disable no-unused-vars */
import React from 'react';
import { render } from 'react-dom';
import LearningEverywhere from '@nackle/learning-everywhere';
import './styles/styles.less';

async function renderLearningEverywhereWidget(  { accessToken, 
    environment,
    pageSize, locale, classNames = '', containerId = 'widget-app',
    paginateRequest,
    orderBy,
    orderAscending,
    excludeCompletedCourses,
    useSegmentationFilter, layout = 'horizontal',
    maxImageWidth = 300, maxImageHeight = 300,
    showCompleteIcon = true,
    showPlayIcon = true,
    showResumeIcon = true,
    listSize = 'small',
    imageSize = 'large',
    imageShape = 'square',
    paginatorPosition = 'bottom',
    paginatorSize = 'large',
    buttonSize = 'small',
    buttonShape = 'square',
    showDescription = false
 } 
) {

    render(
        <LearningEverywhere 
            accessToken={ accessToken } 
            environment={ environment }
            locale={ locale || 'en-US' } 
            excludeCompletedCourses={ excludeCompletedCourses }
            pageSize={ pageSize } 
            listSize= { listSize }
            imageSize= { imageSize }
            imageShape= { imageShape }
            classNames={ classNames } 
            paginateRequest={ paginateRequest }
            orderBy={ orderBy }
            orderAscending={ orderAscending }
            useSegmentationFilter={ useSegmentationFilter }
            layout= { layout }
            maxImageWidth={ maxImageWidth }
            maxImageHeight={ maxImageHeight } 
            showCompleteIcon={ showCompleteIcon }
            showPlayIcon={ showPlayIcon }
            showResumeIcon={ showResumeIcon }
 
            paginatorPosition = { paginatorPosition }
            paginatorSize= { paginatorSize }
            buttonSize= { buttonSize }
            buttonShape= { buttonShape }
            showDescription= { showDescription }
        />,
        document.getElementById( containerId )
    );
}

window.renderLearningEverywhereWidget = renderLearningEverywhereWidget;
